// import I18n from "react-native-i18n";
import en from "./local/en";
import ur from "./local/ur";
let I18n = {};
I18n = en;
// Enable fallbacks if you want `en-US` and `en-GB` to fallback to `en`
// I18n.fallbacks = true;
// I18n.defaultLocale = "fr";
// I18n.translations = {
//   en,
//   fr
// };

export const setLanguage = language => {
  switch (language) {
    case "ur-PK":
      I18n = ur;
      break;
    case "en":
      I18n = en;
      break;

    default:
      I18n = en;
  }
  //   I18n.locale = language;
};

export default I18n;
